import { useState, useEffect } from 'react';

export const useCookies = () => {
  const [cookies, setCookies] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {

    const fetchCookies = async () => {
      try {
        const res = await fetch('/api/cookies', {
          method: 'POST',
          credentials: 'include',
        });
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const jsonResponse = await res.json();
       
      } catch (err: any) {
        console.log(err)
      }
    };

    fetchCookies();
  }, []);

  return { cookies, error };
};
